// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_slick-carousel.js"

// Import Slick
import 'slick-carousel/slick/slick.min';

import fontawesome from '@fortawesome/fontawesome'
import solid from '@fortawesome/fontawesome-pro-solid'
//import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter'
import faFacebooksquare from '@fortawesome/fontawesome-free-brands/faFacebooksquare'
import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin'
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram'
/*
import faCircle from '@fortawesome/fontawesome-pro-regular/faCircle'
import chevronRight from '@fortawesome/fontawesome-pro-light/faChevronRight'
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook'

fontawesome.library.add(chevronRight)
fontawesome.library.add(faCircle)
fontawesome.library.add(faFacebook)
*/

fontawesome.library.add(solid, faFacebooksquare, faLinkedin, faInstagram)

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js